import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { listColleges } from '../actions/collegeActions'
import { universitySearchJson } from '../models/universitySearchModel';

export default function Universities() {
    const [uni, setuni] = useState({})
    const dispatch = useDispatch()

    const collegeList = useSelector((state) => state.collegeList)
    const { loading, error, colleges } = collegeList

    useEffect(() => {
        if (colleges == undefined || colleges.length == 0) {
            dispatch(listColleges({
                searchtxt: '',
                pagesize: '2500',
                pageno: '1',
                countryid: '',
                partnership: ''
            }))
        }
    }, [dispatch, colleges])

    return (
        loading ? (
            <option value="0">loading...</option>
        ) : (
            colleges ? (
                (colleges.length > 0) ? (
                    colleges.map(coll => (
                        <option key={coll.University_Id} value={coll.University_Id}>{coll.University_Name}</option>
                    ))
                ) : (
                    <option value="">No Record Exist!</option>
                )
            ) : (
                <option value="">{error}</option>
            )
        )
    )
}
